import React, { useContext } from 'react';
import { useInteractionContext } from './InteractionContext';
import { useMouseContext } from './MouseContext';
import { useSvgContext } from './SvgContext';
import useMemoObject from './useMemoObject';

// EventContext combines all handlers from SvgContext, InteractionContext and MouseContext. While
// these contexts are frequently updated, the handlers are constant. This way the handlers can be
// used in the whole chart but in contrast to its origin contexts without causing component updates

const EventContext = React.createContext<any>({});

export const EventContextProvider = ({ children }: any) => {
  // those contexts trigger a lot of updates
  const { setWidth, updatePadding, updatePaddingIfLarger } = useSvgContext();
  const { handleHoverTick, handleMouseEnter, handleMouseLeave, handleClick, hoveredTick } =
    useInteractionContext();
  const { setMouse } = useMouseContext();

  const value = useMemoObject({
    setWidth,
    updatePadding,
    updatePaddingIfLarger,
    handleHoverTick,
    handleMouseEnter,
    handleMouseLeave,
    handleClick,
    setMouse,
    hoveredTick,
  });

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
};
export const useEventContext = () => useContext(EventContext); // constants from variables
